<script>
    import ContentSection from "../ContentSection.svelte";
    import { _ } from "svelte-i18n";

    export let openingHours = [];
</script>

<div style="margin-top: 16px;">
    <ContentSection title={$_("opening_hours")}>
        <div slot="content">
            {#each openingHours as openingHour}
                <div class="headline-xs sub-headline">
                    {openingHour.day}
                </div>
                <div style="margin-top: 8px;" class="hours text-l">
                    {openingHour.hours}
                </div>
            {/each}
            <div class="text-m notice">
                <slot name="hoursNotice" />
            </div>
        </div>
    </ContentSection>
</div>

<style>
    .sub-headline {
        font-size: 18px;
        margin-top: 16px;
    }

    .notice {
        color: var(--black-64);
        padding: 16px 0 0 0;
    }

    @media only screen and (min-width: 1440px) {
        .sub-headline {
            margin-top: 0;
        }

        .hours {
            margin-bottom: 16px;
        }

        .notice {
            padding: 16px 320px 0 0;
        }
    }
</style>
